import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDriving = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a,.b{fill:none;}.a{stroke:#24a81b;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-width:2.5px;}" }) }),
		/* @__PURE__ */ _jsxs("g", {
			transform: "translate(3.333 6.667)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M4.367,0,0,1.667",
					transform: "translate(28.967 8.333)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M4.383,1.667,0,0",
					transform: "translate(0 8.333)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M4.167.5H0",
					transform: "translate(22.917 16.167)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M4.167.5H0",
					transform: "translate(6.25 16.167)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M24.587,10l-1.4-6.687A4.169,4.169,0,0,0,19.108,0H5.642A4.166,4.166,0,0,0,1.585,3.218L0,10",
					transform: "translate(4.378)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M2.083,16.667h3.75a2.5,2.5,0,0,0,2.5-2.5V12.5H25v1.667a2.5,2.5,0,0,0,2.5,2.5h3.75a2.084,2.084,0,0,0,2.083-2.083V5a5,5,0,0,0-5-5H5A5,5,0,0,0,0,5v9.583A2.084,2.084,0,0,0,2.083,16.667Z",
					transform: "translate(0 10)"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M0,0H40V40H0Z"
		})
	]
});
export default SvgDriving;
